/**************************************************
 * Nombre:       Seccion_Movimientos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import Dialogo_Movimiento from "../Dialogos/Dialogo_Movimiento";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import {ESTADOMOVIMIENTOS} from "../../Constantes";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import {where} from "firebase/firestore";
import {arrConteoColMesesAtrasWheresSuma} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtrasWheresSuma";


const Seccion_Movimientos = () => {
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const [numDepositos, setNumDepositos] = useState([])
    const [numRetiros, setNumRetiros] = useState([])
    const [numRendimientos, setNumRendimiento] = useState([])
    const [locales, setLocales] = useState([])
    const [w, setW] = useState([])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres: w});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Movimiento,
        titulo: 'Detalles del Movmiento',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
                break
            default :
                abrir(data)
        }
    }

    const obtenerDatos = async () => {


        let wP = [where('tipo', '==', 'Deposito')]
        let doxDepositos = await arrConteoColMesesAtrasWheresSuma({
            coleccion: 'movimientos', mesesAtras: 12, wheres: wP,
            propiedad: 'valor'
        });
        setNumDepositos(doxDepositos)


        let wR = [where('tipo', '==', 'Retiro')]
        let doxRetiros = await arrConteoColMesesAtrasWheresSuma({
            coleccion: 'movimientos',
            mesesAtras: 12,
            wheres: wR,
            propiedad: 'valor'
        });
        setNumRetiros(doxRetiros)

        let wRen = [where('tipo', '==', 'Rendimiento')]
        let doxRendi = await arrConteoColMesesAtrasWheresSuma({
            coleccion: 'movimientos',
            mesesAtras: 12,
            wheres: wRen,
            propiedad: 'valor'
        });
        setNumRendimiento(doxRendi)

        let locales_ = await arrConteoColPropiedadEstados({
            coleccion: 'movimientos',
            propiedad: 'estado',
            arrEstados: ESTADOMOVIMIENTOS.map((it) => it.nombre).reverse(),
        })

        setLocales(locales_)


    }


    useEffect(() => {
        obtenerDatos().then((data) => {
        })
    }, []);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Movimientos'}
                        subtitulo={'Ultimos 12 meses'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: 'Depositos',
                                    data: numDepositos.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Retiros',
                                    data: numRetiros.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Rendimientos',
                                    data: numRendimientos.map((it) => it.cantidad)

                                },
                            ]
                        }
                        labels={numDepositos.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Segun'}
                        subtitulo={'estado'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={20}
                        height={altoGraficas - 40}
                        series={
                            [{
                                name: 'Movimientos',
                                data: locales.map((e) => e.cantidad),
                            }]
                        }
                        labels={ESTADOMOVIMIENTOS.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Movimientos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Movimientos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Fecha y Num',
        direccion: 'left',
        propiedades: ['consecutivo', 'tipo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Correo',
        direccion: 'left',
        propiedad: 'correo',
        titulo: 'nombres',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOMOVIMIENTOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]